import React from 'react';
import TextMessage from '../conv-message/text-message/text-message';
import TextListMessage from '../conv-message/text-list-message/text-list-message';
import ButtonOption from '../conv-message/button-option';
import SwapCardList from '../conv-message/cards/SwapCardList';
import CustomMessage from "../conv-message/custom-message/custom-message";

export default function BotMessageFactory(props) {
  const {type} = props;
  let comp;
  // The TEXT branch was missing its `else`, so a TEXT message fell through the
  // chain and every later `else if` was evaluated against it - leaving `comp`
  // reassigned to undefined for anything that matched twice.
  if (type === 'TEXT') {
    comp = <TextMessage {...props} />;
  } else if (type === 'TEXT_LIST') {
    comp = <TextListMessage {...props} />;
  } else if (type === 'CARDS') {
    comp = <SwapCardList {...props} />;
  } else if (type === 'BUTTON_TEXT') {
    comp = <ButtonOption {...props} />;
  } else if (type === 'CUSTOM') {
    comp = <CustomMessage {...props} />
  } else {
    // An unrecognised type used to render nothing at all, which looked like a
    // dropped message; show the payload instead so it is at least visible.
    comp = <CustomMessage {...props} />;
  }
  return comp;
}
